import { render, staticRenderFns } from "./Jump-sczshome.vue?vue&type=template&id=813038d2&scoped=true"
import script from "./Jump-sczshome.vue?vue&type=script&lang=js"
export * from "./Jump-sczshome.vue?vue&type=script&lang=js"
import style0 from "./Jump-sczshome.vue?vue&type=style&index=0&id=813038d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813038d2",
  null
  
)

export default component.exports